import { Radio } from 'antd';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import FormItem from 'components/FormItem';
import style from './style.scss';

interface RadioSelectProps {
    name: string;
    label: ReactNode;
    options: Array<{
        label: ReactNode;
        value: string | number;
        description?: ReactNode;
    }>;
    $defaultValue?: string | number;
}

const RadioSelect: FC<RadioSelectProps> = ({ name, label, options, $defaultValue }) => {
    return (
        <FormItem name={name} label={label} $defaultValue={$defaultValue}>
            {({ value, onChange }) =>
                options.map(item => (
                    <div
                        key={item.value}
                        className={classNames(style.item, { 'align-items-start': item.description })}
                        onClick={() => onChange(item.value)}>
                        <Radio checked={value === item.value} />
                        <div>
                            <div>{item.label}</div>
                            {item.description && <div className={style.description}>{item.description}</div>}
                        </div>
                    </div>
                ))
            }
        </FormItem>
    );
};

export default RadioSelect;
